/* ======================================================================
   MAPA VIVO (3-sep-2026)

   El sitio cobra y muestra precios con un mapa que hasta hoy venia congelado
   dentro del tema (pc-conexion) y habia que regenerar a mano cada vez que
   cambiaba algo en Shopify. Este guion lo lee de Shopify EN CADA CARGA:

     1. Si hay un mapa guardado en el navegador (menos de 24 h), lo pone en
        pc-conexion antes de que arranquen los modulos que lo leen. Asi la
        pagina abre al instante con lo ultimo que se vio.
     2. Pregunta a la Storefront API (misma llave publica que usa layering),
        reconstruye el mapa con la MISMA logica que rehacer_mapa_nube.py y lo
        guarda.
     3. Si no habia mapa guardado, los modulos esperan la respuesta (maximo
        2.5 s) y arrancan con datos frescos. Si lo habia y Shopify trae algo
        distinto (un precio, una publicacion), guarda lo nuevo y recarga UNA
        vez para que todo el sitio quede parejo.
     4. Si Shopify no responde, se queda con el mapa del tema. Nunca se queda
        sin precios.

   Lo que sigue siendo del sitio: nombres, notas, escenas y fotos. Eso no
   cambia desde Shopify.
   ====================================================================== */
(function(){
  "use strict";
  var TOKEN = "7d64e957478ff08d8a172591a06a20b9";
  var API = "https://velantis.mx/api/2024-10/graphql.json";
  var LLAVE = "velantis_mapa_vivo", TTL = 24 * 3600 * 1000, ESPERA_MAX = 10000; /* 4-sep: 10 s desde DOMContentLoaded; las secciones ya no esperan y una recarga de 15 MB cuesta mas que esperar */
  var DF = {"Scent Diffuser 3000":"DF002","Vertical Smart Diffuser":"DF003","Scent Diffuser 300":"DF004",
            "M22 Diffuser":"DF005","Aroma Diffuser":"DF006","Portable Plug-in Diffuser":"DF007"};
  var CLAVES = ["variantes","precios","variantes50","precios50","bolsillo","aceites","difusores","difusorAromas","sin_variante"];

  var nodo = document.getElementById("pc-conexion");
  var nodoLp = document.getElementById("lp-cfg");
  if(!nodo && !nodoLp) return;

  function canon(s){ var t = String(s || "").trim().toUpperCase(); var m = /^V0*(\d+)$/.exec(t); return m ? "V" + ("00" + m[1]).slice(-3) : t; }
  function leerJSON(n){ try{ return JSON.parse(n.textContent) || {}; }catch(e){ return {}; } }
  function firma(cx){ var o = {}; CLAVES.forEach(function(k){ o[k] = cx[k]; }); return JSON.stringify(o); }
  function ahora(){ return Date.now(); }

  /* ---------------------------------------------------------- memoria */
  var cache = null;
  try{ var c = JSON.parse(localStorage.getItem(LLAVE) || "null"); if(c && c.t && ahora() - c.t < TTL) cache = c; }catch(e){}
  function guardar(cx, tallas){ try{ localStorage.setItem(LLAVE, JSON.stringify({t: ahora(), cx: cx, tallas: tallas})); }catch(e){} }

  function inyectar(cx, tallas){
    if(nodo && cx){ var base = leerJSON(nodo); CLAVES.forEach(function(k){ if(cx[k] !== undefined) base[k] = cx[k]; }); nodo.textContent = JSON.stringify(base); }
    if(nodoLp && tallas){ var cfg = leerJSON(nodoLp); if(cfg.tienda){ cfg.tienda.tallas = tallas; nodoLp.textContent = JSON.stringify(cfg); } }
  }
  var arrancoConCache = false;
  if(cache){ inyectar(cache.cx, cache.tallas); arrancoConCache = true; }

  /* ---------------------------------------------------------- Shopify */
  function gql(query, variables){
    return fetch(API, {method:"POST", headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":TOKEN},
                       body: JSON.stringify({query:query, variables:variables || {}})})
      .then(function(r){ return r.json(); }).then(function(d){ if(d.errors) throw new Error(d.errors[0].message); return d.data; });
  }
  var Q = "query($c:String){ products(first:250, after:$c){ pageInfo{ hasNextPage endCursor } nodes{ title productType onlineStoreUrl variants(first:25){ nodes{ id title sku price{ amount } availableForSale } } } } }";
  function todos(){
    var acc = [];
    function pagina(c){ return gql(Q, {c:c}).then(function(d){ acc = acc.concat(d.products.nodes); return d.products.pageInfo.hasNextPage ? pagina(d.products.pageInfo.endCursor) : acc; }); }
    return pagina(null);
  }

  /* --------------------------------------------- reconstruir el mapa */
  function construir(productos, base){
    var porSku = {}, todosSku = {}, por50 = {}, por30 = {}, aromas = {}, difusor = null;
    productos.forEach(function(p){
      if(!p.onlineStoreUrl) return;                     /* sin URL no se puede cobrar por enlace */
      if(p.productType === "Aroma difusor"){
        var m = /^AR\d+\s+(.*?)\s+·\s+Aroma/.exec(p.title || ""); var nom = m ? m[1].trim() : (p.title || "").trim();
        aromas[nom] = {}; p.variants.nodes.forEach(function(v){ if(v.availableForSale) aromas[nom][v.title] = [v.id.split("/").pop(), +v.price.amount]; });
        return;
      }
      if(p.productType === "difusor de fragancias" && /Difusor de Aceite/i.test(p.title || "")){
        difusor = {}; p.variants.nodes.forEach(function(v){ if(v.availableForSale) difusor[v.title] = [v.id.split("/").pop(), +v.price.amount]; });
      }
      p.variants.nodes.forEach(function(v){
        var s = canon(v.sku); if(!s || !v.availableForSale) return;
        if(/^\d{3}$/.test(s)) s = "V" + s;
        var id = v.id.split("/").pop(), pr = +v.price.amount;
        if(/-50$/.test(s) || v.title === "50 ml"){ por50[s.replace(/-50$/, "")] = [id, pr]; return; }
        if(/-30$/.test(s) || v.title === "30 ml"){ por30[s.replace(/-30$/, "")] = id; return; }
        (todosSku[s] = todosSku[s] || []).push(p.title);
        if(!porSku[s]) porSku[s] = [id, pr, p.title];
      });
    });
    /* un codigo en dos productos distintos no se adivina: se retira */
    Object.keys(todosSku).forEach(function(s){ var t = {}; todosSku[s].forEach(function(x){ t[x] = 1; }); if(Object.keys(t).length > 1){ delete porSku[s]; delete por50[s]; delete por30[s]; } });

    var CAT = window.VELANTIS_CAT || [];
    var skuDe = {}; CAT.forEach(function(f){ if(f && f[0] && f[12]) skuDe[f[0]] = canon(f[12]); });
    var antes = base.variantes || {}, preciosAntes = base.precios || {};
    var nuevas = {}, precios = {};
    var candidatos = Object.keys(antes).slice(); Object.keys(skuDe).forEach(function(n){ if(!(n in antes)) candidatos.push(n); });
    var idsDePerfume = {}; Object.keys(skuDe).forEach(function(n){ var e = porSku[skuDe[n]]; if(e) idsDePerfume[e[0]] = 1; });
    candidatos.forEach(function(n){
      var s = skuDe[n];
      if(s && porSku[s]){ nuevas[n] = porSku[s][0]; precios[n] = porSku[s][1]; }
      else if(s){ /* retirado: su codigo no esta o no se vende */ }
      else if(n in antes){ var vid = antes[n]; if(!idsDePerfume[vid]){ nuevas[n] = vid; precios[n] = preciosAntes[n] || 0; } }
    });
    /* podar lo que no existe en el sitio */
    var enSitio = {}; CAT.forEach(function(f){ if(f && f[0]) enSitio[f[0]] = 1; }); Object.keys(window.VELANTIS_LHS || {}).forEach(function(k){ enSitio[k] = 1; });
    Object.keys(nuevas).forEach(function(n){ if(!enSitio[n]) { delete nuevas[n]; delete precios[n]; } });
    /* difusores */
    var difusores = [];
    Object.keys(DF).forEach(function(n){ var e = porSku[DF[n]]; if(e){ nuevas[n] = e[0]; precios[n] = e[1]; difusores.push(n); } });
    var difusorAromas = {};
    if(difusor && Object.keys(difusor).length){
      difusores.unshift("Velantis Diffuser"); difusorAromas["Velantis Diffuser"] = Object.keys(difusor);
      Object.keys(difusor).forEach(function(a){ nuevas["Velantis Diffuser · " + a] = difusor[a][0]; precios["Velantis Diffuser · " + a] = difusor[a][1]; });
      /* 4-sep: precio base de la tarjeta = el menor entre sus aromas */
      precios["Velantis Diffuser"] = Math.min.apply(null, Object.keys(difusor).map(function(a){ return difusor[a][1]; }));
    }
    /* tallas y frasco de bolsillo */
    var v50 = {}, p50 = {}, bols = {};
    Object.keys(nuevas).forEach(function(n){ var s = skuDe[n]; if(!s) return; if(por50[s]){ v50[n] = por50[s][0]; p50[n] = por50[s][1]; } if(por30[s]) bols[n] = por30[s]; });
    /* aceites */
    var aceites = [];
    Object.keys(aromas).forEach(function(nom){ var t = aromas[nom]; if(!t["100 ml"]) return; aceites.push(nom);
      Object.keys(t).forEach(function(tam){ nuevas[nom + " · Aceite " + tam] = t[tam][0]; precios[nom + " · Aceite " + tam] = t[tam][1]; });
      if(!(nom in nuevas)){ nuevas[nom] = t["100 ml"][0]; precios[nom] = t["100 ml"][1]; } });
    aceites.sort();
    var sinVariante = []; CAT.forEach(function(f){ if(f && f[0] && !(f[0] in nuevas)) sinVariante.push({sku: skuDe[f[0]] || "", nombre: f[0]}); });
    /* mapa de la pagina de layering: por codigo base */
    var tallas = {"100":{variantes:{}, precios:{}, lista:590}, "50":{variantes:{}, precios:{}, lista:390}};
    productos.forEach(function(p){ if(p.productType !== "Perfume" || !p.onlineStoreUrl) return;
      p.variants.nodes.forEach(function(v){ var s = canon(v.sku); if(!s || !v.availableForSale) return; var b = canon(s.replace(/-50$/, "").replace(/-30$/, ""));
        if(v.title === "100 ml" && !/-50$|-30$/.test(s)){ tallas["100"].variantes[b] = v.id.split("/").pop(); tallas["100"].precios[b] = +v.price.amount; }
        else if(v.title === "50 ml"){ tallas["50"].variantes[b] = v.id.split("/").pop(); tallas["50"].precios[b] = +v.price.amount; } }); });
    return { cx: {variantes:nuevas, precios:precios, variantes50:v50, precios50:p50, bolsillo:bols, aceites:aceites, difusores:difusores, difusorAromas:difusorAromas, sin_variante:sinVariante}, tallas: tallas };
  }

  /* ------------------------------------------------------- arranque
     Regla: los modulos leen el mapa UNA vez, al arrancar. Por eso aqui se
     recuerda con que firma arrancaron (firmaAplicada). Si Shopify responde
     despues y trae otra cosa, se guarda y se recarga UNA vez (marca por
     firma completa, no por su largo: $589 -> $590 no cambia el largo). */
  var resolver, listo = new Promise(function(r){ resolver = r; }), firmaAplicada = null;
  function hash(t){ var h = 5381; for(var i = 0; i < t.length; i++) h = ((h << 5) + h + t.charCodeAt(i)) | 0; return (h >>> 0).toString(36) + ":" + t.length; }
  function arrancar(){ if(firmaAplicada !== null) return; firmaAplicada = firma(nodo ? leerJSON(nodo) : {}); resolver(); }
  window.MAPA_VIVO = { listo: listo, estado: arrancoConCache ? "memoria" : "tema", fecha: cache ? cache.t : null };
  if(arrancoConCache) arrancar();                       /* los modulos arrancan ya, con lo guardado */
  /* 4-sep: la espera se cuenta desde que la pagina termino de leerse (es de
     15 MB y tarda varios segundos). Contada desde el arranque del guion, el
     plazo vencia antes de terminar de leerla y casi toda primera visita
     arrancaba con el mapa del tema y luego recargaba: doble carga. */
  var temporizador = null;
  function vencer(){ if(window.MAPA_VIVO.estado === "tema") window.MAPA_VIVO.estado = "tema (Shopify tardo; se recarga al llegar)"; arrancar(); }
  function contar(){ if(firmaAplicada === null && !temporizador) temporizador = setTimeout(vencer, ESPERA_MAX); }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", contar); else contar();

  var baseTema = nodo ? leerJSON(nodo) : {};
  todos().then(function(productos){
    var r = construir(productos, baseTema), nuevaFirma = firma(r.cx);
    guardar(r.cx, r.tallas);
    clearTimeout(temporizador);
    if(firmaAplicada === null){                          /* llego a tiempo: los modulos arrancan con Shopify */
      inyectar(r.cx, r.tallas); window.MAPA_VIVO.estado = "shopify"; window.MAPA_VIVO.fecha = ahora(); arrancar();
      /* 4-sep: la ficha de coleccion (#/lhs/...) no es modulo diferido: si la URL
         ya la traia, se pinto con el mapa del tema antes de que llegara Shopify.
         Se le pide que se vuelva a pintar con el mapa recien inyectado. */
      if(/^#\/lhs\//.test(location.hash)){ try{ window.dispatchEvent(new HashChangeEvent("hashchange")); }catch(e){} }
      return;
    }
    if(nuevaFirma === firmaAplicada){ window.MAPA_VIVO.estado = "memoria = shopify"; window.MAPA_VIVO.fecha = ahora(); return; }
    /* los modulos arrancaron con otro mapa (cache vieja o tema): una sola recarga por firma */
    var marca = "velantis_mv_recarga", h = hash(nuevaFirma);
    try{ if(sessionStorage.getItem(marca) !== h){ sessionStorage.setItem(marca, h); window.MAPA_VIVO.estado = "recargando"; location.reload(); return; } }catch(e){}
    window.MAPA_VIVO.estado = "memoria (Shopify cambio; se aplica en la proxima carga)";
  }).catch(function(e){ clearTimeout(temporizador); window.MAPA_VIVO.error = String(e && e.message || e); arrancar(); });
})();
